import { Badge } from '@/components/ui/badge';
import { useI18n } from '@/hooks/useI18n';
import { cn } from '@/components/utils/utils';

interface ExternalAgentBadgeProps {
    className?: string;
}

/**
 * Segnala che il contatto del viaggio e' un agente di viaggio, non il viaggiatore finale
 * (`travel_requests.requester_type = 'advisor'`, scelto da chi compila la richiesta).
 *
 * Sta accanto al nome perche' e' li' che serve: in elenco il contatto e' l'unico appiglio
 * per capire con chi si sta parlando, e un intermediario che rivende non si distingue da
 * un cliente finale guardando nome ed email.
 */
export const ExternalAgentBadge = ({ className }: ExternalAgentBadgeProps) => {
    const { t } = useI18n();

    return (
        <Badge
            className={cn(
                'bg-blue-600 text-white border-transparent hover:bg-blue-600 shrink-0',
                className
            )}
        >
            {t('itinerary.externalAgent')}
        </Badge>
    );
};
